import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'
import { futureGoals } from '../../data/timeline'

export default function FuturSection() {
  return (
    <SectionWrapper
      id="futur"
      gradient="from-dark-secondary via-primary-pink/10 to-dark-primary"
    >
      {/* Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>🔮</span>
          <span>Le Futur</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Et Après ?
        </motion.h2>

        <motion.p
          className="text-lg text-light-pink-100/70"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          Nos rêves et projets pour la suite de notre histoire
        </motion.p>
      </motion.div>

      {/* Future Goals */}
      <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto mb-16">
        {futureGoals.map((goal, index) => (
          <motion.div
            key={goal.id}
            className="glass-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15 }}
            whileHover={{ scale: 1.02, y: -5 }}
          >
            <div className="flex items-start gap-4">
              <motion.span
                className="text-4xl"
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 2, repeat: Infinity, delay: index * 0.2 }}
              >
                {goal.emoji}
              </motion.span>
              <div>
                <h3 className="text-lg font-bold text-white mb-1">{goal.title}</h3>
                <p className="text-light-pink-100/70 text-sm">{goal.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* The Big Declaration */}
      <motion.div
        className="max-w-4xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <motion.div
          className="glass-card pink-glow text-center py-12"
          initial={{ scale: 0.9 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, type: 'spring' }}
        >
          {/* Hearts Animation */}
          <motion.div
            className="flex justify-center gap-2 mb-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            {['💕', '💖', '💗', '💝', '💘'].map((heart, i) => (
              <motion.span
                key={i}
                className="text-3xl"
                animate={{ scale: [1, 1.3, 1], y: [0, -10, 0] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: i * 0.15 }}
              >
                {heart}
              </motion.span>
            ))}
          </motion.div>

          <motion.h3
            className="text-3xl md:text-5xl font-serif font-bold mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <span className="gradient-text">Je veux t'épouser.</span>
          </motion.h3>

          <motion.p
            className="text-xl md:text-2xl text-light-pink-100/80 mb-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            Je veux vieillir à tes côtés.
          </motion.p>

          <motion.p
            className="text-lg text-light-pink-100/70 max-w-xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.7 }}
          >
            Je veux que chaque jour soit une continuation de cette belle histoire.
          </motion.p>

          {/* Ring Emoji */}
          <motion.div
            className="mt-8"
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 1, type: 'spring', bounce: 0.5 }}
          >
            <motion.span
              className="text-6xl inline-block"
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ duration: 3, repeat: Infinity }}
            >
              💍
            </motion.span>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "Je veux t'épouser, vieillir à tes côtés
          <br />
          Chaque jour avec toi est une éternité"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Finale
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
